const sec5_cont = document.getElementById("ab-sec5-cont");

let isAnimated_sec5 = false;

window.addEventListener("scroll", () => {

    const sec5_cont_top = sec5_cont.getBoundingClientRect().top;

    if(sec5_cont_top <=500 && !isAnimated_sec5){

        animateTextSec5();
        isAnimated_sec5 = true;
    }
});

function animateTextSec5(){

    const sec5_text_h1 = document.getElementById("sec5-main-text-h1");

    sec5_text_h1.innerHTML = wrapTextInSpanSec5(`THE HANDS 
BEHIND 
        EVERY BAR`);
    
}

function wrapTextInSpanSec5(textSec5) {
  let letterDelaySec5 = 0;
  let stepDelaySec5 = 0.03;
  return textSec5
    .split('')
    .map(char => {
      
      console.log(letterDelaySec5);
      const safeCharSec5 = char === ' ' ? '&nbsp;' : char;
      const spanSec5 = `<span style="animation-delay: ${letterDelaySec5.toFixed(1)}s">${char}</span>`;
      letterDelaySec5 = letterDelaySec5 + stepDelaySec5;
      return spanSec5;
    })
    .join('');
}

